
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/copyright-policy",
      function () {
        return require("private-next-pages/legal/copyright-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/copyright-policy"])
      });
    }
  